export class HcPagination {
  private _pageIndex: number;
  private _pageSize: number;
  private _totalItems: number;

  constructor() {
    this._pageIndex = 0;
    this._pageSize = 10;
    this._totalItems = 0;
  }

  public reset() {
    this._pageIndex = 0;
    this._pageSize = 10;
    this._totalItems = 0;
  }

  public setPageIndex(pageIndex: number): void {
    this._pageIndex = pageIndex;
  }

  public setPageSize(pageSize: number): void {
    this._pageSize = pageSize;
  }

  public setTotal(total: number): void {
    this._totalItems = total;
  }

  public getPageIndex(): number {
    return this._pageIndex;
  }

  public getPageSize(): number {
    return this._pageSize;
  }

  public getTotal(): number {
    return this._totalItems;
  }
}
